var definitionList = 'fx_2d2fb1e5_14nggi00';

export { definitionList };
//# sourceMappingURL=definitionList.vanilla.mjs.map
